var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.3,114.6c-3.8,3.8-12,5.2-17.9,5.2s-14-1.4-17.9-5.2c-.9-.9-2.4-.9-3.3,0s-.9,2.4,0,3.3c6.1,6.1,17.7,6.5,21.1,6.5s15.1-.5,21.1-6.5c.9-.9.9-2.4,0-3.3s-2.1-.9-3.1,0h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.1,85.5c-4.9,0-8.9,4-8.9,8.9s4,8.9,8.9,8.9,8.9-4,8.9-8.9-4-8.9-8.9-8.9Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5,0C38.3,0,0,38.3,0,85.5s38.3,85.5,85.5,85.5,85.5-38.3,85.5-85.5S132.7,0,85.5,0ZM135,96.8c.2,1.2.3,2.5.3,3.8,0,19.2-22.3,34.7-49.8,34.7s-49.8-15.5-49.8-34.7c0-1.3.1-2.5.3-3.8-4.3-1.9-7.4-6.3-7.4-11.4-.1-6.8,5.5-12.4,12.4-12.4,3.3,0,6.4,1.3,8.6,3.5,8.6-6.2,20.5-10.2,33.8-10.6l6.3-29.8c.1-.6.5-1.1,1-1.4s1.1-.4,1.7-.3l20.7,4.4c1.5-2.9,4.4-5,7.9-5,4.9,0,8.9,4,8.9,8.9s-4,8.9-8.9,8.9-8.6-3.8-8.9-8.5l-18.5-3.9-5.6,26.7c13.1.5,24.8,4.4,33.3,10.6,2.2-2.2,5.3-3.5,8.6-3.5,6.9,0,12.5,5.6,12.5,12.5,0,5-3,9.4-7.4,11.3h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8,94.4c0-4.9-4-8.9-8.9-8.9s-8.9,4-8.9,8.9,4,8.9,8.9,8.9,8.9-4,8.9-8.9Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedditIcon);
export default __webpack_public_path__ + "static/media/redditIcon.8fd658ac08e3045227c26e61f40371a3.svg";
export { ForwardRef as ReactComponent };